// @flow
import React, { Component, type ComponentType } from "react";
import Spinner from "@atlaskit/spinner";

import { Outer, PhotoHolder, Third, Half } from "./styled";

type Props = {|
    images: ComponentType<any>,
    Photo: ComponentType<any>
|};

class ImageQueue {
    constructor(images) {
        this.images = images;
        this.index = 0;
    }
    shift() {
        this.index += 1;
        return this.index - 1;
    }
    remaining() {
        return this.images.length - this.index;
    }
}

class Photos extends Component<Props> {
    onePhoto = (Photo, imageQueue, key) => {
        const p1 = imageQueue.shift();
        const layout = (
            <Half key={key}>
                <Photo images={imageQueue.images} index={p1} />
            </Half>
        );

        return layout;
    };
    twoPhotos = (Photo, imageQueue, key) => {
        const p1 = imageQueue.shift();
        const p2 = imageQueue.shift();
        const layout = (
            <div key={key}>
                <Half>
                    <Photo images={imageQueue.images} index={p1} />
                </Half>
                <Half>
                    <Photo images={imageQueue.images} index={p2} />
                </Half>
            </div>
        );

        return layout;
    };
    threePhotos = (Photo, imageQueue, key) => {
        const p1 = imageQueue.shift();
        const p2 = imageQueue.shift();
        const p3 = imageQueue.shift();
        const layout = (
            <div key={key}>
                <Third>
                    <Photo images={imageQueue.images} index={p1} />
                </Third>
                <Third>
                    <Photo images={imageQueue.images} index={p2} />
                </Third>
                <Third>
                    <Photo images={imageQueue.images} index={p3} />
                </Third>
            </div>
        );

        return layout;
    };
    fivePhotosLeft = (Photo, imageQueue, key) => {
        const p1 = imageQueue.shift();
        const p2 = imageQueue.shift();
        const p3 = imageQueue.shift();
        const p4 = imageQueue.shift();
        const p5 = imageQueue.shift();
        const layout = (
            <div key={key}>
                <Half>
                    <Photo images={imageQueue.images} index={p1} />
                </Half>
                <Half>
                    <PhotoHolder>
                        <Half>
                            <Photo images={imageQueue.images} index={p2} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p3} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p4} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p5} />
                        </Half>
                    </PhotoHolder>
                </Half>
            </div>
        );

        return layout;
    };

    fivePhotosRight = (Photo, imageQueue, key) => {
        const p1 = imageQueue.shift();
        const p2 = imageQueue.shift();
        const p3 = imageQueue.shift();
        const p4 = imageQueue.shift();
        const p5 = imageQueue.shift();
        const layout = (
            <div key={key}>
                <Half>
                    <PhotoHolder>
                        <Half>
                            <Photo images={imageQueue.images} index={p1} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p2} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p3} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p4} />
                        </Half>
                    </PhotoHolder>
                </Half>
                <Half>
                    <Photo images={imageQueue.images} index={p5} />
                </Half>
            </div>
        );

        return layout;
    };

    eightPhotos = (Photo, imageQueue, key) => {
        const p1 = imageQueue.shift();
        const p2 = imageQueue.shift();
        const p3 = imageQueue.shift();
        const p4 = imageQueue.shift();
        const p5 = imageQueue.shift();
        const p6 = imageQueue.shift();
        const p7 = imageQueue.shift();
        const p8 = imageQueue.shift();
        const layout = (
            <div key={key}>
                <Half>
                    <PhotoHolder>
                        <Half>
                            <Photo images={imageQueue.images} index={p1} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p2} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p3} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p4} />
                        </Half>
                    </PhotoHolder>
                </Half>
                <Half>
                    <PhotoHolder>
                        <Half>
                            <Photo images={imageQueue.images} index={p5} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p6} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p7} />
                        </Half>
                        <Half>
                            <Photo images={imageQueue.images} index={p8} />
                        </Half>
                    </PhotoHolder>
                </Half>
            </div>
        );

        return layout;
    };

    render() {
        const { images, Photo } = this.props;

        if (images === undefined) {
            return <Spinner size="medium" />;
        } else if (images.length === 0) {
            return <div />;
        }

        const content = [];
        const imageQueue = new ImageQueue(images);
        let keyIndex = 0;
        while (imageQueue.remaining() > 0) {
            keyIndex += 1;
            let layouts;
            if (imageQueue.remaining() >= 8) {
                layouts = [
                    this.eightPhotos,
                    this.fivePhotosLeft,
                    this.fivePhotosRight,
                    this.threePhotos,
                    this.twoPhotos
                ];
            } else if (imageQueue.remaining() >= 5) {
                layouts = [
                    this.fivePhotosLeft,
                    this.fivePhotosRight,
                    this.threePhotos,
                    this.twoPhotos
                ];
            } else if (imageQueue.remaining() >= 3) {
                layouts = [this.threePhotos];
            } else if (imageQueue.remaining() === 2) {
                layouts = [this.twoPhotos];
            } else if (imageQueue.remaining() === 1) {
                layouts = [this.onePhoto];
            } else {
                return content;
            }

            const random = Math.floor(Math.random() * layouts.length);
            const key = `photo-${keyIndex}`;
            const layout = layouts[random];
            const renderedLayout = layout(Photo, imageQueue, key);
            content.push(renderedLayout);
        }

        return <Outer>{content}</Outer>;
    }
}

export default Photos;



// WEBPACK FOOTER //
// ./src/blog-card/photos/view.js